/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Statistics_Interviews_HeldInputs */

const en_admin_statistics_interviews_held = /** @type {(inputs: Admin_Statistics_Interviews_HeldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interviews held`)
};

const de_admin_statistics_interviews_held = /** @type {(inputs: Admin_Statistics_Interviews_HeldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stattgefundene Gespräche`)
};

/**
* | output |
* | --- |
* | "Interviews held" |
*
* @param {Admin_Statistics_Interviews_HeldInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_statistics_interviews_held = /** @type {((inputs?: Admin_Statistics_Interviews_HeldInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Statistics_Interviews_HeldInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_statistics_interviews_held(inputs)
	return en_admin_statistics_interviews_held(inputs)
});